import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";

import SectionContactUs from "../HomePage/Sections/SectionContactUs";
// core components
import Header from "components/Header/Header.js";
import Footer from "components/Footer/Footer.js";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import HeaderLinks from "components/Header/HeaderLinks.js";
import Parallax from "components/Parallax/Parallax.js";

import styles from "assets/jss/material-kit-react/views/workPage.js";

import laptop from "assets/img/work/hcoa/laptop.png";
import iphone1 from "assets/img/work/hcoa/iPhone-X1.png";
import iphone2 from "assets/img/work/hcoa/iPhone-X2.png";
import iphone3 from "assets/img/work/hcoa/iPhone-X3.png";
import brochure from "assets/img/work/hcoa/brochure.png";
import longScreens from "assets/img/work/hcoa/longscreens-HCOA.png";
import headerImg from "assets/img/work/hcoa/header.png";

const useStyles = makeStyles(styles);

export default function ProfilePage(props) {
  const classes = useStyles();
  const mainClasses = classNames({
    [classes.main]: true,
    [classes.hcoa]: true
  });
  const { ...rest } = props;
  
  return (
    <div>
      <Header
        color="white"
        rightLinks={<HeaderLinks />}
        fixed
        changeColorOnScroll={{
          height: 400,
          color: "white"
        }}
        {...rest}
      />
      <Parallax className="hcoa" small image={headerImg}>
        <div className="portfolio-client-name hcoa">
          <span>H</span>
          <span>C</span>
          <span>O</span>
          <span>A</span>
        </div>
        <div className="portfolio-title hcoa">
          HERIA CENTERS OF AMERICA
        </div>
      </Parallax>
      <div className={mainClasses}>
        <div>
          <div className={classes.container}>
            <h1 className={classes.title}>Hernia Centers Of America</h1>
            <GridContainer justify="flex-start">
              <GridItem xs={12} sm={12} md={8}>
              <p>A manufacturer partners with practices to launch centers of excellence for the treatment of hernias. Hernia repairs can be dicey. So we broke it down for patients, and built a treatment pathway that included a DTC website, nurse consults, email nurturing & brochures that included the very mesh patients would receive. Transparency and access: the heartbeat of what consumers desire from healthcare brands.</p>
              </GridItem>
            </GridContainer>
          </div>
          <div className={classes.container}>
            <GridContainer justify="flex-start">
              <GridItem xs={12} sm={12} md={12}>
                <img alt="" src={laptop} />
              </GridItem>
            </GridContainer>
          </div>

          <div className="vertical-holder print top">
            <div className={classes.container} style={{marginTop:'100px'}}>
              <GridContainer justify="center" className="flex-center">
                <div className="item questions"><img alt="" src={brochure} /></div>
              </GridContainer>
            </div>
          

            <div className="vertical-holder story">
              <div className={classes.container} style={{marginTop:'100px'}}>
                <GridContainer justify="center" className="flex-center">
                  <div className="item longscreens"><img alt="" src={longScreens} /></div>
                </GridContainer>
              </div>
            </div>
          </div>

          <div className={classes.container} style={{marginTop:'100px'}}>
            <GridContainer justify="center" className="flex-center">
              <div className="item iphone"><img alt="" src={iphone1} /></div>
              <div className="item iphone"><img alt="" src={iphone2} /></div>
              <div className="item iphone"><img alt="" src={iphone3} /></div>
            </GridContainer>
          </div>
          
          <div className={classes.container}>
            <SectionContactUs />
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}
